export const DoneIcon = () => {
  return (
    <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.57994 7C3.37994 7 3.18994 6.92187 3.04994 6.78514L0.219941 4.02128C-0.0700586 3.73805 -0.0700586 3.26927 0.219941 2.98605C0.509941 2.70283 0.989941 2.70283 1.27994 2.98605L3.57994 5.2323L8.71994 0.212417C9.00994 -0.0708057 9.48994 -0.0708057 9.77994 0.212417C10.0699 0.49564 10.0699 0.964422 9.77994 1.24765L4.10994 6.78514C3.96994 6.92187 3.77994 7 3.57994 7Z"
        fill="white"/>
    </svg>
  );
};